module.exports = __webpack_public_path__ + "static/media/Screenshot 2024-08-18 at 11.56.06.eb9757e4.png";